module.exports = __webpack_public_path__ + "img/share.ccb6b845.png";